import React, { useState } from "react";
import Dropzone from "react-dropzone";
import Axios from "axios";
import { MdAddToPhotos } from "react-icons/md";
import { toast } from "react-hot-toast";
import { baseURL } from "../../configs/axiosConfig";

function ImageUploadS3(props) {
  const [Images, setImages] = useState([]);

  const onDrop = (files) => {
    let formData = new FormData();
    const config = {
      header: { "content-type": "multipart/form-data" },
    };
    formData.append("file", files[0]);

    Axios.post(`${baseURL}/api/products/uploadImageS3`, formData, config).then(
      (response) => {
        if (response.data.success) {
          const newImages = [...Images, response.data.location];
          setImages(newImages);
          props.refreshFunction(newImages);
          toast.success("Successfully uploaded picture");
          console.log(response.data.location);
        } else {
          toast.error("Failed to save the image on server");
        }
      }
    );
  };

  const onDelete = (image) => {
    const currentIndex = Images.indexOf(image);

    let newImages = [...Images];
    newImages.splice(currentIndex, 1);

    setImages(newImages);
    props.refreshFunction(newImages);
  };

  return (
    <div className="flex flex-col relative items-start space-y-4">
      <Dropzone onDrop={onDrop} multiple={false} maxSize={800000000}>
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps()}
            className="
              flex flex-col items-center justify-center
              w-64 h-32
              border-2 border-dashed border-gray-400
              rounded-lg cursor-pointer
              hover:border-blue-500 hover:bg-gray-100
              transition duration-300 ease-in-out
              text-gray-500 text-sm font-medium
              p-4
            "
          >
            <input {...getInputProps()} />
            <MdAddToPhotos className="text-2xl mb-2" />
            <span>Add photos</span>
            <p className="text-xs text-gray-400 mt-1">
              Release to drop files here
            </p>
          </div>
        )}
      </Dropzone>

      <div className="grid grid-cols-3 gap-4 mt-4">
        {Images.map((image, index) => (
          <div
            key={index}
            onClick={() => onDelete(image)}
            className="
              relative
              w-32 h-32
              overflow-hidden
              rounded-lg
              shadow-md
              cursor-pointer
              hover:opacity-75
              transition duration-300
            "
          >
            <img
              src={image}
              alt={`productImg-${index}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ImageUploadS3;
